export const LEARN_AGENT = [
  {
    mainHead: "Agents",
    mainDisc: "Discover Talent with Film Help Squad",
    mainSubDesc:
      "Are you an agent in search of the next rising star? Look no further! Film Help Squad is your ultimate destination for finding top talent in the world of film and entertainment. Whether you represent actors, directors, writers, or other creative professionals, our platform offers the tools and resources you need to connect with the brightest stars and emerging talents in the industry.",
    subData: [
      {
        subHead: "Why Use Film Help Squad for Finding Talents?",
        subHeadData: [
          {
            subHeadType: "Unlock New Opportunities:",
            subDesc:
              "Film Help Squad opens doors to a global network of talented individuals actively seeking representation. Discover fresh faces and seasoned pros looking for their next big break.",
          },
          {
            subHeadType: "Streamlined Talent Discovery:",
            subDesc:
              "Our platform offers a user-friendly interface with advanced search and filtering options, making it easy for agents to pinpoint the perfect talent for their projects.",
          },
          {
            subHeadType: "Access to Diverse Talent Pools:",
            subDesc:
              "Discover talents from various backgrounds, genres, and specializations. Our platform celebrates diversity, ensuring you have access to a wide array of creative professionals.",
          },
        ],
      },
      {
        subHead: "Features and Benefits:",
        subHeadData: [
          {
            subHeadType: "1. Robust Talent Profiles:",
            subDesc:
              "View comprehensive talent profiles that showcase résumés, portfolios, showreels, and work history.",
          },
          {
            subHeadType: "2. Instant Connection:",
            subDesc:
              "Connect directly with talents through our messaging system, streamlining communication and collaboration.",
          },
          {
            subHeadType: "3. Talent Scouting:",
            subDesc:
              "Scout for talents based on specific criteria such as skills, location, availability, and more.",
          },
          {
            subHeadType: "4. Collaboration Hub:",
            subDesc:
              "Collaborate effortlessly with talents, schedule auditions, and manage projects seamlessly.",
          },
          {
            subHeadType: "5. Event Notifications:",
            subDesc:
              "Stay informed about casting calls, auditions, and industry events that match your interests.",
          },
          {
            subHeadType: "6. Secure and Privacy-Focused:",
            subDesc:
              "Rest assured that your data and communications are secure, and you have control over your privacy settings.",
          },
        ],
      },
      {
        subHead: "Tools:",
        subHeadData: [
          {
            subHeadType: "1. Talent Search:",
            subDesc:
              "Utilize our advanced search tools to find talents that meet your specific criteria.",
          },
          {
            subHeadType: "2. Talent Messaging:",
            subDesc:
              "Communicate with talents directly through our platform, making it easy to discuss opportunities and negotiate.",
          },
          {
            subHeadType: "3. Portfolio Management:",
            subDesc: `Keep track of your talent roster and their work, ensuring you're always ready to pitch them for exciting roles.`,
          },
        ],
      },
    ],
    howWorkData: [
      {
        heading: "How It Works:",
        subHW: [
          {
            q: "Create Your Agent Profile:",
            ans: "Sign up as an agent and complete your profile to get started.",
          },
          {
            q: "Browse and Search:",
            ans: "Explore our diverse talent database to find talents that match your requirements.",
          },
          {
            q: "Connect and Collaborate:",
            ans: "Reach out to talents, discuss potential collaborations, and manage your connections effortlessly.",
          },
          {
            q: "Stay Informed:",
            ans: "Receive notifications about casting calls, industry events, and talent updates.",
          },
          {
            q: "Build Your Roster:",
            ans: "Add talents to your roster, manage their profiles, and represent them effectively. ",
          },
        ],
      },
    ],
    footerText: 'Join Film Help Squad today and elevate your talent scouting game! Our platform is designed to simplify the talent discovery process, so you can focus on what you do best – shaping careers and bringing exceptional talents to the forefront of the entertainment industry. Start your journey with Film Help Squad now!'
  },
];
